<script lang="ts">
	import type { LoadResult } from '@kestrel/server';
	import type { load } from './ProductTeaserServer.ts';
	import { TeaserType } from '../../../domain/teaser/TeaserType.ts';
	import ToSignUp from '../../../components/teaser/large/ToSignUp.svelte';
	import ToLogin from '../../../components/teaser/large/ToLogin.svelte';
	import OldToBooster from '../../../components/teaser/large/OldToBooster.svelte';
	import ToBooster from '../../../components/teaser/large/ToBooster.svelte';

	let { data }: { data: LoadResult<typeof load> } = $props();
	const teaserSize = 'MediaObject100';

</script>

{#if !data.disableProductTeaser}
	{#if data.teaserType === TeaserType.NO_CONTENT || !data.teaserContent}
		<div data-testid="no-content-teaser-container" data-tracking-teaser-no-content-reason={data.noContentReason}></div>
	{:else if data.teaserType === TeaserType.TO_LOGIN}
		<ToLogin
			teaserContent={data.teaserContent}
			teaserSize={teaserSize}
		/>
	{:else if data.teaserType === TeaserType.BOOSTER_TEASER}
		{#if data.showBoosterCampaignRedesign}
			<ToBooster teaserContent={data.teaserContent} teaserType={TeaserType.BOOSTER_TEASER} />
		{:else}
			<OldToBooster
				teaserContent={data.teaserContent}
			/>
		{/if}
	{:else if data.teaserType === TeaserType.NON_UP_PLUS_BOOSTER_TEASER}
		{#if data.showBoosterCampaignRedesign}
			<ToBooster teaserContent={data.teaserContent} teaserType={TeaserType.NON_UP_PLUS_BOOSTER_TEASER} />
		{/if}
	{:else}
		<ToSignUp
			teaserContent={data.teaserContent}
			teaserType={data.teaserType}
			teaserSize={teaserSize}
			teaserTouchPoint={data.teaserTouchPoint}
		/>
	{/if}
{/if}
